const isAuto = (links: ClaimInfoLink[]): boolean => {
    if (links.length > 1) {
        return true;
    }
    return !links[0].streetAddress && !!links[0].make;
};

export default isAuto;
